import UtilityService from "../../../../services/UtilityService";

const anyRunOfWhitespace = /\s+/;

export const describeCorrespondenceSource = ({ fromCorrespondence }) => {
	if (!fromCorrespondence) {
		return null;
	}

	const { quote, pastedAt, pastedByName, isCurrent } = fromCorrespondence;

	const quoteText = quote || "";
	const quoteWords = quoteText.trim().split(anyRunOfWhitespace);
	const quoteOnOneLine = quoteWords.join(" ");
	const pastedOn = UtilityService.formatDate({ value: pastedAt, format: "D MMM YYYY" });
	const sourceSentence = `From the client's correspondence, pasted by ${pastedByName} on ${pastedOn}: “${quoteOnOneLine}”`;

	if (isCurrent === false) {
		const replacedSentence = `${sourceSentence} (since replaced by newer instructions)`;
		return replacedSentence;
	}

	return sourceSentence;
};
